module.exports = __webpack_public_path__ + "img/rodrigos.f3621305.jpg";